import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

/**
 * PageHeader - Consistent page header with icon, title, and subtitle
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - Page subtitle/description
 * @param {React.ReactNode} props.icon - Icon to display in avatar
 * @param {string} props.iconColor - Avatar background color (default: 'primary.main')
 * @param {React.ReactNode} props.actions - Action buttons to display on the right
 * @param {React.ReactNode} props.children - Additional content below the header
 */
const PageHeader = ({
  title,
  subtitle,
  icon,
  iconColor = 'primary.main',
  actions,
  children,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {icon && (
            <Avatar
              sx={{
                backgroundColor: iconColor,
                width: 48,
                height: 48,
                mr: 2,
              }}
            >
              {icon}
            </Avatar>
          )}
          <Box>
            <Typography
              variant="h4"
              sx={{ fontWeight: 600, color: 'text.primary' }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {actions && <Box sx={{ display: 'flex', gap: 2 }}>{actions}</Box>}
      </Box>
      {children}
    </Box>
  );
};

export default PageHeader;
